import { MoreVert } from "@mui/icons-material";
import { IconButton, ListItem, Tooltip, Typography } from "@mui/material";
import { useMemo, useState } from "react";

import Svg from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import ViewDocumentModal from "../../Documents/ViewDocuments/components/ViewDocumentModal";
import { useContractsRowMenuHandlers } from "../hooks/useEventHandlers";
import { getContractFileName, getContractFileUrl } from "../utils/contractFormUtils";
import { STRINGS } from "../utils/strings";

import ContractsDropdownMenu from "./ContractsDropdownMenu";

export default function ContractsListItem({
  data,
  onDelete = () => {},
  onEdit = () => {},
  canEdit = false,
  canDelete = false,
}) {
  const RESULT_CLASSES = "text-sm text-center px-0 py-2 self-center";
  const [viewDocument, setViewDocument] = useState(false);
  const {
    contractFile,
    contractFileName,
    contractName,
    startDate,
    termDate,
    employerIdentificationNumber,
    pipState,
  } = data;
  const fileName = getContractFileName(contractFileName);
  const fileUrl = getContractFileUrl(contractFile);
  const activeDoc = useMemo(
    () => ({ file: fileUrl, fileName }),
    [fileName, fileUrl]
  );
  const showActions = canEdit || canDelete;
  const { anchorEl, menuOpen, handleMenuOpen, handleMenuClose, handleEdit, handleDelete } =
    useContractsRowMenuHandlers({ data, onDelete, onEdit });

  return (
    <>
      <ListItem className="border-b border-gray-200 px-0 hover:bg-gray-50">
        <div className="flex w-full items-center">
          <div className={`${RESULT_CLASSES} w-[15%]`}>
            <div className="flex items-center gap-2">
              <Tooltip title={fileUrl ? "View Document" : "No File Preview Available"}>
                <div
                  className={fileUrl ? "cursor-pointer pt-1" : "cursor-not-allowed pt-1 opacity-50"}
                  onClick={() => fileUrl && setViewDocument(true)}
                >
                  <Svg name="his-file-search" color={HNSColors.primary[500]} />
                </div>
              </Tooltip>
              <Tooltip title={fileName || "No file"}>
                <Typography className="truncate text-sm">{fileName}</Typography>
              </Tooltip>
            </div>
          </div>
        <div className={`${RESULT_CLASSES} w-[15%]`}>{contractName}</div>
        <div className={`${RESULT_CLASSES} w-[15%]`}>{startDate}</div>
        <div className={`${RESULT_CLASSES} w-[15%]`}>{termDate}</div>
        <div className={`${RESULT_CLASSES} w-[15%]`}>
          {employerIdentificationNumber}
        </div>
        <div className={`${RESULT_CLASSES} w-[15%]`}>{STRINGS.PIP_OPTS[pipState]}</div>
        {showActions && (
          <div className={`${RESULT_CLASSES} flex w-[5%] items-center justify-center gap-2`}>
            <IconButton
              id={`contracts-row-menu-button-${data.id}`}
              size="small"
              onClick={handleMenuOpen}
            >
              <MoreVert sx={{ color: HNSColors.primary[500], fontSize: 24 }} />
            </IconButton>

            <ContractsDropdownMenu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              contractId={data.id}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          </div>
        )}
        </div>
      </ListItem>
      <ViewDocumentModal
        viewDocument={viewDocument}
        closeDocModal={() => setViewDocument(false)}
        activeDoc={activeDoc}
      />
    </>
  );
}
